import React, { Component } from 'react';
import { Button } from 'antd';
import Text from '../../../../basicElement/Text';
import TableC from '../../../../basicElement/TableC';
import EditableCell from '../../../../basicElement/EditableCell';
import format from '../../../../shared/format';
import SortOrder from '../Components/SortOrder';

class Milestone extends Component {
    state = {
        data: [
            {milestoneNode: '本协议完成签署'},
            {milestoneNode: '首例受试者完成入组'},
            {milestoneNode: 'Ia期50%受试者完成入组'},
            {milestoneNode: '合计'},
        ],
        totalCount: 10205047.48,
    }

    getColumns = () => {
        const { names, editable } = this.props;
        const { data } = this.state;
        const len = data.length;
        const columns = [{
            title: names.paymentPlan,
            dataIndex: 'paymentPlan',
            key: 'paymentPlan',
            width: 160,
            render: (text, record, index) => {
                if (index !== len - 1) {
                    return `第${index + 1}笔付款`;
                }
            }
        }, {
            title: <Text asterisk={editable}>{names.milestoneNode}</Text>,
            dataIndex: 'milestoneNode',
            key: 'milestoneNode',
            width: 240,
            render: (text, record, index) => {
                if (index !== len - 1) {
                    const { newAdd } = record;
                    return (
                        <EditableCell
                            type="Input"
                            editable={editable || newAdd}
                            value={text}
                            placeholder={names.inputPlaceholder}
                            onChange={e => this.handleInputChange(e, index, 'milestoneNode')}
                        />
                    );
                } else {
                    return <strong>{text}</strong>;
                }
            }
        }, {
            title: <Text asterisk={editable}>{names.paymentPercentage}</Text>,
            dataIndex: 'paymentPercentage',
            key: 'paymentPercentage',
            width: 200,
            render: (text, record, index) => {
                if (index !== len - 1) {
                    const { newAdd } = record;
                    return (
                        <div>
                            <EditableCell
                                type="Number"
                                editable={editable || newAdd}
                                value={text}
                                style={{ width: '90%' }}
                                placeholder={names.inputPlaceholder}
                                config={{max: 100, precision: 2}}
                                onChange={value => this.handleNumberChange(value, index, 'paymentPercentage')}
                            />
                            &nbsp;%
                        </div>
                    );
                } else {
                    return text ? <strong>{text} %</strong> : '';
                }
            }
        }, {
            title: names.serviceFee,
            dataIndex: 'serviceFee',
            key: 'serviceFee',
            width: 180,
            render: (text, record, index) => {
                if (index !== len - 1) {
                    return format('money', text);
                } else {
                    return <strong>{format('money', text)}</strong>;
                }
            }
        }, {
            title:  names.comments,
            dataIndex: 'comments',
            key: 'comments',
            render: (text, record, index) => {
                const { newAdd } = record;
                return (
                    <EditableCell
                        type="Input"
                        editable={editable || newAdd}
                        value={text}
                        placeholder={names.inputPlaceholder}
                        onChange={e => this.handleInputChange(e, index, 'comments')}
                    />
                );
            }
        }];
        if (editable) {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 80,
                render: (text, record, index) => {
                    return <a onClick={() => this.handleDelete(index, record)}>删除</a>;
                }
            });
        }
        return columns;
    }

    handleAdd = () => {
        const { data } = this.state;
        data.splice(data.length - 1, 0, { newAdd: true });
        this.setState({ data });
    }

    handleDelete = (index, record) => {
        const { data } = this.state;
        const { newAdd } = data[index];
        if (newAdd) {
            data.splice(index, 1);
        }
        this.setState({ data });
    }

    handleInputChange = (e, index, key) => {
        const { data } = this.state;
        data[index][key] = e.target.value;
        this.setState({ data });
    }

    handleNumberChange = (value, index, key) => {
        const { data, totalCount } = this.state;
        const len = data.length;
        data[index][key] = value;
        data[index]['serviceFee'] = (value || 0) * totalCount;

        let percentage = 0, total = 0;
        data.forEach((item, index) => {
            const { paymentPercentage, serviceFee } = item;
            if (index !== len - 1) {
                total += Number(serviceFee || 0);
                percentage += Number(paymentPercentage || 0);
            }
        });
        data[len - 1]['paymentPercentage'] = (percentage || 0).toFixed(2);
        data[len - 1]['serviceFee'] = (total || 0).toFixed(2);
        this.setState({ data });
    }

    sort = () => {
        const { data } = this.state;
        const len = data.length;
        const arr = [];
        data.forEach((item, index) => {
            if (index !== len - 1) {
                arr.push(item);
            }
        });
        this.sortRef.show(arr);
    }

    handleSort = (list) => {
        const { data } = this.state;
        data.splice(0, list.length, ...list);
        this.setState({ data });
    }

    render() {
        const { typeName, editable } = this.props;
        const { data } = this.state;
        return (
            <div>
                <div style={{ margin: '10px 0', padding: '0 10px', width: '60%', lineHeight: '32px', background: '#f1f1f1' }}>
                    付款金额总计：
                    <span style={{marginRight: 4, color: '#F00', fontWeight: 'bold'}}>10,205,047.48</span>
                    元
                    <span className="ant-divider" />
                    付款计划类型：
                    { typeName }
                </div>
                {
                    editable &&
                    <div style={{ margin: '-42px 0 10px', lineHeight: '32px', textAlign: 'right' }}>
                        <Button type="primary" style={{marginRight: 10}} onClick={this.sort}>调整顺序</Button>
                        <Button type="primary" onClick={this.handleAdd}>添加节点</Button>
                    </div>
                }
                <TableC
                    data={data}
                    columns={this.getColumns()}
                    className="quotation_milestone"
                />
                <SortOrder ref={el => this.sortRef = el} onSort={this.handleSort} />
            </div>
        );
    }
}

export default Milestone;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Payment/Table/Milestone.js